var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcToiletFemale = function SvgIcToiletFemale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    fill: "none",
    viewBox: "0 0 33 33"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF6363",
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "m22.736 21.402-1.871-7.315c-.154-.602-.547-1.145-1.114-1.532a3.55 3.55 0 0 0-1.998-.602h-3.02c-.723 0-1.437.214-1.998.602-.56.387-.96.93-1.114 1.532l-1.872 7.315c-.084.34.007.691.266.96.26.268.638.429 1.052.429h1.479c.21 0 .392.125.434.298l1.36 5.204c.203.763.981 1.3 1.906 1.3s1.703-.537 1.907-1.3l1.36-5.204c.041-.173.224-.298.434-.298h1.479c.406 0 .792-.155 1.051-.43a.99.99 0 0 0 .266-.96zM16.249 10.076a3.147 3.147 0 1 0 0-6.294 3.147 3.147 0 0 0 0 6.294Z"
  })));
};
export default SvgIcToiletFemale;